import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { submitRequestData, resetSubmitRequestData } from "./submit-request-data";

const initialState: ProcessingState = { processing: "idle" };

export const submitRequestDataReducer = createReducer<ProcessingState>(initialState, builder => {
  builder
    .addCase(submitRequestData.fulfilled, state => {
      return {
        ...state,
        processing: "success",
      };
    })
    .addCase(submitRequestData.pending, state => {
      return {
        ...state,
        processing: "pending",
      };
    })
    .addCase(submitRequestData.rejected, state => {
      return {
        ...state,
        processing: "failed",
      };
    });
  builder.addCase(resetSubmitRequestData, () => {
    return initialState;
  });
});
